// extracted by mini-css-extract-plugin
export default {"sidebar":"CoursesAndBooksSidebar_sidebar__xfM6o"};